import IMG_0017 from "../../assets/3500 IU Sugar Free (Pack of 4)/IMG_0017.webp";
import IMG_9994 from "../../assets/3500 IU Sugar Free (Pack of 4)/IMG_9994.webp";
import RightArrow from "../../assets/right-arrow-svgrepo-com.svg";

export const Assets = {
  IMG_0017,
  IMG_9994,
  RightArrow,
};

export function slugify(name) {
  return decodeURIComponent(name) // Decode %20 etc.
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // Remove special chars except dash
    .replace(/\s+/g, "-") // Replace spaces with dashes
    .replace(/-+/g, "-") // Replace multiple dashes with single
    .trim();
}
